module.exports = __webpack_public_path__ + "img/CONNECT_WOORECEIVER.16e9d124.svg";